function checkTokenAndSetPreorder() {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  
  if (token) {
    localStorage.setItem('preorderAllowed', 'true');
  }
}

checkTokenAndSetPreorder();

function isPreorderAllowed() {
  return localStorage.getItem('preorderAllowed') === 'true';
}

const preorderButtons = document.querySelectorAll('[data-preorder-button="true"], button:has([data-preorder-button="true"])');

preorderButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    event.preventDefault();
    
    if (isPreorderAllowed()) {
      const productForm = button.closest('.shopify-product-form');
      if (productForm) {
        const form = productForm.querySelector('form') || productForm;
        if (form.tagName === 'FORM') {
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        }
      }
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'RJnW5U']);
    }
  });
});